export class TipoIdentificacion {
    constructor(
        public id: string,
        public idTipo: string,
        public nombre: string,
        public codigoPos: string,
        public codigoSura: string) { }
}